export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-video-fafa72ffde1c6800540fd079b2cb60b5.svg";